import lottie from 'lottie-web';
import { loadFonts } from '@loaders/FontLoader';

export default class LoadScene extends Phaser.Scene {
  constructor() {
    super({ key: 'LoadScene' });
  }

  async preload() {
    this.load.json('loading-anim', 'assets/loadAnims/cuemath_loading.json');
    await loadFonts();
  }

  create() {
    this.loadingAnim = this.addLoaderLottie(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
    );

    this.assetsLoad();
    this.load.start();

    this.load.on(
      'progress',
      () => {
        this.loadingAnim.anim.playSegments([0, 25], true);
      },
      this,
    );

    this.load.on(
      'complete',
      () => {
        this.loadingAnim.anim.loop = false;
        this.loadingAnim.anim.playSegments([26, 41], true);
        this.loadingAnim.anim.addEventListener('complete', () => {
          this.scene.start('StartScene');
        });
      },
      this,
    );
  }

  addLoaderLottie(_x, _y) {
    const lottieRef = this.add
      .dom(_x - this.cameras.main.width / 2, _y - this.cameras.main.height / 2, 'div')
      .setScale(0.7);

    const lottieDiv = lottieRef.node;
    lottieDiv.style.height = '100%';
    lottieDiv.style.width = '100%';

    const lottieAnim = lottie.loadAnimation({
      container: lottieDiv,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      animationData: this.cache.json.get('loading-anim'),
    });

    return { anim: lottieAnim, dom: lottieRef };
  }

  assetsLoad() {
    // Audio
    this.load.audio('bgMusic', 'assets/Audio/BGMusic.mp3');
    this.load.audio('erfloor', 'assets/Audio/elevatorArrives atFloor.mp3');
    this.load.audio('edopen', 'assets/Audio/elevatorDoorOpening.mp3');
    this.load.audio('emoving', 'assets/Audio/elevatorMoving.mp3');
    this.load.audio('confettiWelcome', 'assets/Audio/confettiWelcome.mp3');
    this.load.audio('ebpress', 'assets/Audio/elevatotButtonPress.mp3');
    this.load.audio('incorrectAudio', 'assets/Audio/incorrectAnswer.mp3');
    this.load.audio('logoAudio', 'assets/Audio/logoReveal.mp3');

    // Game Scene atlases & animations
    this.load.multiatlas(
      'CharacterQ1Anim',
      'assets/GameSceneAssets/CharacterQ1/CharacterQ1Anim.json',
      'assets/GameSceneAssets/CharacterQ1',
    );
    this.load.atlas(
      'checkConfettiAnim',
      'assets/GameSceneAssets/checkConfettiAnim.png',
      'assets/GameSceneAssets/checkConfettiAnim.json',
    );
    this.load.atlas(
      'hintFinalAnim',
      'assets/GameSceneAssets/hintFinalAnim.png',
      'assets/GameSceneAssets/hintFinalAnim.json',
    );

    // Start Scene assets
    this.load.image('play_button', 'assets/StartSceneAssets/play_button.png');
    this.load.image('play_button_on', 'assets/StartSceneAssets/play_button_on.png');
    this.load.image('Background', 'assets/StartSceneAssets/Background.png');
    this.load.image('glare', 'assets/StartSceneAssets/glare.png');
    this.load.image('door', 'assets/StartSceneAssets/door.png');
    this.load.image('doorMask', 'assets/StartSceneAssets/doorMask.png');
    this.load.image('bg', 'assets/StartSceneAssets/bg.png');
    this.load.image('build', 'assets/StartSceneAssets/build.png');
    this.load.image('liftDoor', 'assets/StartSceneAssets/liftDoor.png');
    this.load.image('0s', 'assets/StartSceneAssets/0.png');
    this.load.image('GameName', 'assets/StartSceneAssets/GameName.png');
    this.load.image('boy', 'assets/StartSceneAssets/boy.png');
    this.load.image('cloud1', 'assets/StartSceneAssets/cloud1.png');
    this.load.image('cloud2', 'assets/StartSceneAssets/cloud2.png');
    this.load.image('cloud3', 'assets/StartSceneAssets/cloud3.png');
    this.load.image('arrows', 'assets/StartSceneAssets/arrows.png');
    this.load.multiatlas(
      'characterWalkAnim',
      'assets/StartSceneAssets/Character Walk Anim/walkAnim.json',
      'assets/StartSceneAssets/Character Walk Anim',
    );
    this.load.image('shadow', 'assets/StartSceneAssets/shadow.png');

    // Game Scene shadows
    for (let i = 1; i <= 10; i++) {
      this.load.image('shadow' + i, 'assets/GameSceneAssets/shadow' + i + '.png');
    }

    // Game Scene props
    this.load.image('ldoor', 'assets/GameSceneAssets/lDoor.png');
    this.load.image('rdoor', 'assets/GameSceneAssets/rDoor.png');
    this.load.image('lift', 'assets/GameSceneAssets/lift.png');

    // Question / statement / wish images Q1..Q10, QS1..QS10, QW1..QW10
    for (let i = 1; i <= 10; i++) {
      this.load.image('Q' + i, 'assets/GameSceneAssets/Q' + i + '.png');
      this.load.image('QS' + i, 'assets/GameSceneAssets/QS' + i + '.png');
      this.load.image('QW' + i, 'assets/GameSceneAssets/QW' + i + '.png');
    }

    this.load.image('panelBoard', 'assets/GameSceneAssets/panelBoard.png');
    this.load.image('green', 'assets/GameSceneAssets/green.png');
    this.load.image('beed', 'assets/GameSceneAssets/beed.png');
    this.load.image('upArrow', 'assets/GameSceneAssets/upArrow.png');
    this.load.image('downArrow', 'assets/GameSceneAssets/downArrow.png');
    this.load.image('upArrow_on', 'assets/GameSceneAssets/upArrow_on.png');
    this.load.image('downArrow_on', 'assets/GameSceneAssets/downArrow_on.png');
    this.load.image('upArrow_c', 'assets/GameSceneAssets/upArrow_c.png');
    this.load.image('downArrow_c', 'assets/GameSceneAssets/downArrow_c.png');
    this.load.image('upArrow_w', 'assets/GameSceneAssets/upArrow_w.png');
    this.load.image('downArrow_w', 'assets/GameSceneAssets/downArrow_w.png');
    this.load.image('hint', 'assets/GameSceneAssets/Hint.png');
    this.load.image('hint1', 'assets/GameSceneAssets/hint1.png');
    this.load.image('hint2', 'assets/GameSceneAssets/hint2.png');
    this.load.image('closeHint', 'assets/GameSceneAssets/closeHintIconhdpi.png');
    this.load.image('overlay', 'assets/EndSceneAssets/overlay.png');

    // Floor button textures (-5..5 with state suffixes)
    for (let i = -5; i <= 5; i++) {
      this.load.image(i + '_on', 'assets/GameSceneAssets/' + i + '_on.png');
      this.load.image(i + '_c', 'assets/GameSceneAssets/' + i + '_c.png');
      this.load.image(i + '_h', 'assets/GameSceneAssets/' + i + '_h.png');
      this.load.image(i + '_w', 'assets/GameSceneAssets/' + i + '_w.png');
      this.load.image(i + '_d', 'assets/GameSceneAssets/' + i + '_d.png');
      this.load.image(i + '_', 'assets/GameSceneAssets/' + i + '.png');
    }

    // End Scene assets (loaded up-front so EndScene starts cleanly)
    this.load.multiatlas(
      'spotlight',
      'assets/EndSceneAssets/spotlight/spotlightAnimNew.json',
      'assets/EndSceneAssets/spotlight',
    );
    this.load.multiatlas(
      'rewardLight',
      'assets/EndSceneAssets/rewardAnims/rewardLightAnim.json',
      'assets/EndSceneAssets/rewardAnims/',
    );
    this.load.multiatlas(
      'endConfetti',
      'assets/EndSceneAssets/confetti/confettiAnimNew.json',
      'assets/EndSceneAssets/confetti',
    );
    this.load.multiatlas(
      'baseCircle',
      'assets/EndSceneAssets/rewardAnims/baseCircleAnim.json',
      'assets/EndSceneAssets/rewardAnims/',
    );
    this.load.multiatlas(
      'glitter',
      'assets/EndSceneAssets/rewardAnims/glitterAnim.json',
      'assets/EndSceneAssets/rewardAnims/',
    );
    this.load.image('gameOver', 'assets/EndSceneAssets/Game Over.png');
    this.load.image('youWon', 'assets/EndSceneAssets/You won.png');
    this.load.image('rewardEarned', 'assets/EndSceneAssets/Rewards earned!.png');
    this.load.image('correctIcon', 'assets/EndSceneAssets/correctIcon.png');
    this.load.image('incorrectIcon', 'assets/EndSceneAssets/incorrectIcon.png');
    this.load.image('hintIcon', 'assets/EndSceneAssets/hintIcon.png');
    this.load.image('endBG', 'assets/EndSceneAssets/endBG.png');
    this.load.image('okayButton', 'assets/EndSceneAssets/okay.png');
    this.load.image('okayBlack', 'assets/EndSceneAssets/okayBlack.png');
    this.load.image('okayDisabled', 'assets/EndSceneAssets/okayDisabled.png');
    this.load.image('retryButton', 'assets/EndSceneAssets/retry.png');
    this.load.image('retryBlack', 'assets/EndSceneAssets/retryBlack.png');
    this.load.image('nextButton', 'assets/EndSceneAssets/next.png');
    this.load.image('nextBlack', 'assets/EndSceneAssets/nextBlack.png');
    this.load.image('rewardName', 'assets/EndSceneAssets/Compass.png');
    this.load.image('compass', 'assets/EndSceneAssets/mathcompass.png');

    // Pre-load Q2..Q5 character anims so GameScene doesn't need a mid-run load
    for (let i = 2; i <= 5; i++) {
      this.load.multiatlas(
        'CharacterQ' + i + 'Anim',
        'assets/GameSceneAssets/CharacterQ' + i + '/CharacterQ' + i + 'Anim.json',
        'assets/GameSceneAssets/CharacterQ' + i,
      );
    }

    this.load.plugin(
      'rexkawaseblurpipelineplugin',
      'assets/rexkawaseblurpipelineplugin.min.js',
    );
  }

  update() {}
}
